import { enhancementPointColumn } from "../resource/enhancement-point-column";
import { NeededColumn } from "./needed-column";

export const enhancementPointNeededColumn = new NeededColumn(
  "38b39c45-55a1-41fc-a9b2-f71ed027b50e",
  enhancementPointColumn,
  "CP Needed"
)
